import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { OverlayContainer, OverlayModule } from '@angular/cdk/overlay';
import { ActivatedRoute, NavigationError, Router, RouterModule } from '@angular/router';
import { SideNavComponent } from './side-nav.component';
import { TopNavComponent } from './top-nav.component';
import { BehaviorSubject, map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { VersionReloadComponent } from './version-reload.component';
import { filter } from 'rxjs/operators';
import { CanaryService } from './common/canary.service';
import { AppMode, AppState } from './common/app-state';
import { AdminNavComponent } from './admin-nav.component';
import { GlobalDocumentDropComponent } from './document-manager/global-document-drop.component';
import { AppAuthService } from './common';
import { TourService } from './tour/tour.service';
import { UserLanguageSyncService } from './common/auth/user-language-sync.service';
import { LoaderSpinnerComponent } from './loader-spinner.component';
import { HelpChatWidgetComponent } from './help-chat-widget.component';

const DARK_MODE_CLASS = 'dark-mode';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    CommonModule,
    RouterModule,
    TopNavComponent,
    SideNavComponent,
    VersionReloadComponent,
    LoaderSpinnerComponent,
    OverlayModule,
    AdminNavComponent,
    GlobalDocumentDropComponent,
    HelpChatWidgetComponent,
  ],
})
export class AppComponent implements OnInit {
  private readonly overlay = inject(OverlayContainer);
  private readonly router = inject(Router);
  private readonly tourService = inject(TourService);
  private readonly route = inject(ActivatedRoute);
  private readonly canary = inject(CanaryService);
  appState = inject(AppState);
  authService = inject(AppAuthService);
  private readonly _languageSync = inject(UserLanguageSyncService);
  @HostBinding('class') className = '';
  darkmode = new BehaviorSubject(false);
  protected readonly AppMode = AppMode;

  async ngOnInit() {
    this.router.events
      .pipe(
        filter(
          (evt) => evt instanceof NavigationError && evt.error instanceof Error && evt.error.name == 'ChunkLoadError'
        ),
        map((evt) => evt as NavigationError)
      )
      .subscribe((evt) => window.location.assign(evt.url));

    this.darkmode.subscribe((darkMode) => {
      this.className = darkMode ? DARK_MODE_CLASS : '';
      if (darkMode) {
        this.overlay.getContainerElement().classList.add(DARK_MODE_CLASS);
      } else {
        this.overlay.getContainerElement().classList.remove(DARK_MODE_CLASS);
      }
    });

    // Add logged-in class to body
    this.appState.isLoggedIn$.subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        document.body.classList.add('logged-in');
      } else {
        document.body.classList.remove('logged-in');
      }
    });

    this.appState.isLoggedInOnce$.subscribe(() => this.tourService.startPendingTour());

    // `?canary` switches canary mode on from any url. Driven from here, not from CanaryComponent:
    // the badge lives in the toolbar now, which AppMode.HELP does not render.
    this.route.queryParams.subscribe((params) => this.canary.enableFromQueryParams(params));
  }
}
